import styled, { keyframes } from "styled-components";

const spin = keyframes`
  0%   { transform: rotate(0deg); }
  50%  { transform: rotate(180deg); }
  100% { transform: rotate(360deg); }
`;

export const LoaderWrap = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 10px;

  padding: 10px 12px;
  border-radius: 12px;

  background: rgba(255, 255, 255, 0.8);
  box-shadow: 0px 6px 16px rgba(0, 0, 0, 0.12);
  backdrop-filter: blur(2px);
`;

export const Hourglass = styled.div`
  width: 18px;
  height: 26px;
  position: relative;

  border: 2px solid rgba(0, 0, 0, 0.65);
  border-radius: 7px;
  box-sizing: border-box;

  animation: ${spin} 1.4s ease-in-out infinite;

  /* top triangle */
  &::before {
    content: "";
    position: absolute;
    left: 50%;
    top: 5px;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-top: 8px solid rgba(0, 0, 0, 0.65);
    opacity: 0.9;
  }

  /* bottom triangle */
  &::after {
    content: "";
    position: absolute;
    left: 50%;
    bottom: 5px;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-bottom: 8px solid rgba(0, 0, 0, 0.65);
    opacity: 0.9;
  }
`;

export const Label = styled.div`
  font-size: 0.9rem;
  font-weight: 600;
  opacity: 0.8;
`;
